var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopic = function SvgTopic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    className: "topic_svg__design-iconfont"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#696F7F",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.412 6.282c.328.106.51.451.407.77l-.248.75h1.922l.339-1.038c.101-.313.45-.48.778-.374.328.107.512.447.41.76l-.212.652h.488c.335 0 .607.28.607.625a.616.616 0 0 1-.607.625l-.893-.003-.528 1.622h.862c.33 0 .596.28.596.626 0 .345-.266.625-.596.625l-1.268-.001-.398 1.229c-.102.313-.45.48-.778.373-.329-.106-.512-.447-.41-.76l.272-.842h-1.94l-.4 1.217a.62.62 0 0 1-.732.273.62.62 0 0 1-.433-.652l.271-.838H6.43c-.329 0-.596-.279-.596-.624s.267-.625.596-.625l.898-.001.533-1.64-.971-.004a.62.62 0 0 1-.486-.612.62.62 0 0 1 .486-.613H8.26l.37-1.136a.616.616 0 0 1 .782-.384Zm-.248 2.754-.538 1.635h1.935l.53-1.628-1.927-.007Z",
    strokeWidth: 0.5,
    fill: "#696F7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.517a7.46 7.46 0 0 1 5.292 2.191A7.46 7.46 0 0 1 17.483 10a7.46 7.46 0 0 1-2.191 5.292A7.46 7.46 0 0 1 10 17.483a7.452 7.452 0 0 1-3.242-.736l-3.315-.104.415-2.347C2.97 12.919 2.517 11.513 2.517 10a7.46 7.46 0 0 1 2.191-5.292A7.46 7.46 0 0 1 10 2.517Z",
    strokeWidth: 1.7
  }))));
};
export default SvgTopic;